// src/router/index.js
import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  // 根路径路由（必须存在）
  {
    path: '/',
    name: 'HomePage',
    component: () => import('../views/HomePage.vue'),
    props: route => ({ id: route.params.id }) // 手动映射参数[4,7](@ref)
  },
  // 动态参数路由（合并到根路径）
  {
    path: '/chat/:id',
    name: 'ChatPage',
    component: () => import('../views/HomePage.vue'), // 复用组件
    props: true // 自动传递参数[5,8](@ref)
  },
  {
    path: '/aboutPage',
    name: 'aboutPage',
    component: () => import('../views/AboutPage.vue')
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
